export function useCartSplit() {
  const { getItemPrice } = usePriceUtils()

  /**
   * Split cart items by temperature type
   */
  function splitItemsByTemperature(cart: any) {
    const chilledItems = cart.items.filter((item: any) => item.temperatureType === 'CHILLED')
    const ambientItems = cart.items.filter((item: any) => !item.temperatureType || item.temperatureType === 'AMBIENT')

    return { chilledItems, ambientItems }
  }

  /**
   * Calculate total price for a list of items
   */
  function calculateItemsTotal(items: any[]): number {
    return items.reduce((sum: number, item: any) => sum + getItemPrice(item) * item.quantity, 0)
  }

  /**
   * Split cart by temperature type (chilled/ambient) into separate carts
   * Returns separate carts with appropriate freight values for SEPARATE configuration
   */
  function splitCartByTemperature(cart: any) {
    const { chilledItems, ambientItems } = splitItemsByTemperature(cart)

    const chilledTotal = calculateItemsTotal(chilledItems)
    const ambientTotal = calculateItemsTotal(ambientItems)

    const chilledCart = {
      ...cart,
      items: chilledItems,
      totalSum: chilledTotal,
      supplier: {
        ...cart.supplier,
        // Use chilled freight values
        freightAllowance: cart.supplier.freightAllowanceChilled?.amount || cart.supplier.freightAllowance,
        freightCharge: cart.supplier.freightChargeChilled?.amount || cart.supplier.freightCharge,
      },
    }

    const ambientCart = {
      ...cart,
      items: ambientItems,
      totalSum: ambientTotal,
    }

    return {
      chilledCart,
      ambientCart,
      chilledItems,
      ambientItems,
      chilledTotal,
      ambientTotal,
    }
  }

  return {
    splitItemsByTemperature,
    calculateItemsTotal,
    splitCartByTemperature,
  }
}
